import { defineComponent } from '@vue/composition-api';

var script = defineComponent({
    name: 'SdsTabsSecondaryItem',
    props: {
        isActive: {
            type: Boolean,
            required: false,
            default: false,
        },
        isDisabled: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    emits: ['click'],
});

export default script;
